
import img1 from '../images/svg/icon-1.svg'
import img2 from '../images/svg/icon-2.svg'
import img3 from '../images/svg/icon-3.svg'
import img4 from '../images/svg/icon-4.svg'



const dataPortfolio = [

    {
        id: 1,
        img: img1,
        title: 'Discovery & Planning',
        desc: 'We start by understanding your goals, target users, and technical requirements. I define the scope, choose the right stack, and map out a clear project roadmap.'
    },
    {
        id: 2,
        img: img2,
        title: 'Design & Architecture',
        desc: 'I create UI wireframes and establish the system architecture — component structure, API design, database schema, and scalability considerations before writing a single line of code.'
    },
    {
        id: 3,
        img: img3,
        title: 'Development & Testing',
        desc: 'I build the product iteratively with React, Next.js, and Node.js — writing clean, maintainable code with proper testing, code reviews, and continuous integration throughout.'
    },
    {
        id: 4,
        img: img4,
        title: 'Deploy & Optimise',
        desc: 'I handle CI/CD pipelines, cloud deployment, performance audits, and post-launch monitoring — ensuring the product runs fast, stays stable, and is ready to scale.'
    },


]

export default dataPortfolio;